import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Button} from '../../components/Button';
import {DirectoryBar} from '../../components/DirectoryBar';
import {H6} from '../../components/H6';
import {InfoSection} from '../../components/MyPage/InfoSection';
import {MProductCard} from '../../components/MyPage/MProductCard';
import {ProductSection} from '../../components/MyPage/ProductSection';
import {ShippingInfoSection} from '../../components/MyPage/ShippingInfoSection';
import {PopUp} from '../../components/PopUp';
import {Section} from '../../components/Section';
import {Table} from '../../components/Table';
import {getOrderHistoryDetail} from "../../apis/orders";
import {TOrderDetail} from "../../types/types";
import OrderNumberSection from "../../components/OrderNumberSection";
import PaymentInfoPC from "../../components/PaymentInfoPC";
import PaymentInfoMobile from "../../components/PaymentInfoMobile";

export const CancelDetail = () => {
    const {orderNumber} = useParams<{ orderNumber: string }>()
    const [popUp, setPopUp] = useState(false);
    const [order, setOrder] = useState<TOrderDetail>()
    const [prePayment, setPrePayment] = useState({
        willReturnMileage: 0,
        totalPaidProductAmount: 0,
        deliveryAmount: 0,
        totalPrepayingAmount: 0,
        willCancelAmount: 0,
    })

    useEffect(() => {
        getOrderHistoryDetail(orderNumber).then(r => setOrder(r.data.payload)).catch(e => setOrder(undefined));
    }, [orderNumber])

    useEffect(() => {
        let prepaying = {...prePayment}
        // order?.products.filter(item => item.productStatus === 'CANCELED').forEach(item => {
        //     prepaying.willReturnMileage += item.usedMileage
        //     prepaying.totalPaidProductAmount += (item.totalPrice - item.usedMileage)
        // })
        prepaying.willReturnMileage = order?.canceledUsedMileage || 0;
        prepaying.willCancelAmount = order?.canceledBalance || 0;
        setPrePayment(prepaying)
    }, [order])

    if (!order) return null
    return (
        <>
            <DirectoryBar text="주문 취소" backArrow className="md:hidden"/>
            <PopUp
                title="정말 주문을취소하시겠습니까?"
                buttonText="취소하기"
                open={popUp}
                onClose={() => setPopUp(false)}
                onClick={() => window.alert('주문 취소가 완료되었습니다.')}
            />

            <div className="py-4">
                <div className="space-y-14 pb-20">
                    <Section className="space-y-4 text-13">
                        <div className="border-b pb-2">
                            <H6>주문 취소</H6>
                        </div>
                        <OrderNumberSection orderNumber={order.orderNumber} orderedAt={order.orderedAt!}/>
                    </Section>

                    <ProductSection
                        hideActions
                        order={order}
                        content={
                            <>
                                {/* desktop */}
                                <Table className="mt-5 hidden md:table">
                                    <Table.Head>
                                        <Table.Row>
                                            <Table.Th>상품</Table.Th>
                                            <Table.Th>사이즈</Table.Th>
                                            <Table.Th>적립금 적립</Table.Th>
                                            <Table.Th>결제금액</Table.Th>
                                            <Table.Th>취소사유</Table.Th>
                                        </Table.Row>
                                    </Table.Head>
                                    <Table.Body>
                                        {order.products.filter(product => product.productStatus === 'CANCELED').map((apply, index) => (
                                            <Table.Row key={index}>
                                                <Table.Td>
                                                    <MProductCard
                                                        thumbnail={apply.thumbnailUrl}
                                                        name={apply.productName}
                                                        color={apply.brandName}
                                                        price={apply.unitPrice.toLocaleString()}
                                                        quantity={apply.count}
                                                    />
                                                </Table.Td>

                                                <Table.Td>{apply.sizeName}</Table.Td>
                                                <Table.Td>{apply.earnedMileage.toLocaleString()}원</Table.Td>
                                                <Table.Td>
                                                    {apply.totalPrice.toLocaleString()}원
                                                </Table.Td>
                                                <Table.Td>
                                                    {apply.cancelReason || '-'}
                                                </Table.Td>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>

                                {/* mobile */}
                                <Section className="md:hidden">
                                    {order.products.map((apply, index) => (
                                        <div className="flex justify-between items-center border-b pb-4 mb-4" key={index}>
                                            <div className="">
                                                <MProductCard
                                                    thumbnail={apply.thumbnailUrl}
                                                    name={apply.productName}
                                                    color={apply.brandName}
                                                    price={apply.unitPrice.toLocaleString()}
                                                    quantity={apply.count}
                                                    content={
                                                        <div>
                                                            <p className="text-brand-3">
                                                                사이즈: {apply.sizeName}
                                                            </p>
                                                            <p className="text-brand-3">
                                                                적립금 적립: {apply.earnedMileage}
                                                            </p>
                                                        </div>
                                                    }
                                                />
                                            </div>

                                            <p className="text-10 font-bold">{apply.totalPrice.toLocaleString()}원</p>
                                        </div>
                                    ))}
                                </Section>

                                <p className="md:border-t md:border-gray-200 pt-4 flex flex-row-reverse text-12 text-gray-500">
                                    *적립금 적립율 변동 시, 기간별 적립 적립금이 상이 할 수 있습니다.
                                </p>
                            </>
                        }
                    />

                    <InfoSection name={order.customerName || '-'} phone={order.customerPhone || '-'}/>

                    <ShippingInfoSection hideActions order={order}/>

                    <div className={'md:hidden'}>
                        <PaymentInfoMobile order={order} prepaid={prePayment}/>
                    </div>


                    <Section className="text-13 hidden md:block">
                        <H6 className="border-b pb-2">취소 정보</H6>

                        <PaymentInfoPC order={order} prepaid={prePayment}/>

                        {/*{order.status !== 'CANCELED' && (*/}
                        {/*    <Button text="주문 취소하기"*/}
                        {/*            className="filled-brand-1 w-full mt-10"*/}
                        {/*    />*/}
                        {/*)}*/}
                    </Section>
                </div>
            </div>
        </>
    );
};
